// @flow

import React from 'react';
import bemify from 'bemify-js';

import './Confetti.scss';

const bem = bemify('confetti');

export type ConfettiItem = {
  className: string,
  width: string,
  height: string,
  top: string,
  left: string,
  transform: string,
  position: string,
  opacity: number,
  transition?: string,
};

type Props = {
  confettiPieces: Array<ConfettiItem>,
};

const Confetti = (props: Props) => {
  const { confettiPieces } = props;
  return (
    <div className={bem()}>
      {confettiPieces.map((confetti, i) => {
        const {
          className,
          width,
          height,
          top,
          left,
          transform,
          position,
          opacity,
          transition,
        } = confetti;

        return (
          <div
            className={className}
            key={i}
            style={{
              width,
              height,
              top,
              left,
              transform,
              opacity,
              position,
              transition,
            }}
          />
        );
      })}
    </div>
  );
};

export default Confetti;
